import React from "react"
import Container from "../../Container"
import ServiceCard from "./ServiceCard"
import { motion } from "framer-motion"
import { cardVariants } from "../../../utils/animations"
import chevron_up from "../../../images/chevron_up.svg"
import { navigate } from "gatsby"

function CaseStudiesCards({ showMoreBtn, casestudies }) {
  return (
    <Container>
      <div className=" flex flex-col items-center mb-[300px]">
        <div className=" flex flex-col justify-center items-center  ">
          <motion.p
            variants={cardVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.3 }}
            className="text-[#4D4D4D]  text-center mb-[24px] w-full  ]"
          >
            Explore our Case Studies
          </motion.p>
          <motion.p
            variants={cardVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.3 }}
            className="text-[24px] md:text-[32px] font-[700] text-center mb-16"
          >
            Our Case Studies
          </motion.p>
        </div>
        <div className="w-full flex flex-wrap gap-4 justify-center ">
          {casestudies.map((service, index) => (
            <div
              key={index}
              className={`w-[90%] md:w-[45%] lg:w-[30%] self-center flex-0`}
            >
              <ServiceCard link={false} service={service} />
            </div>
          ))}
        </div>

        {showMoreBtn && (
          <motion.div
            variants={cardVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.3 }}
            onClick={() => navigate("/case-studies")}
            className="flex justify-center my-14 items-center gap-2 mb-6 cursor-pointer"
          >
            <p className="text-[#121212] text-center">See more</p>
            <img className="rotate-90" src={chevron_up} alt="" />
          </motion.div>
        )}
      </div>
    </Container>
  )
}

export default CaseStudiesCards
